import Vue from "vue";

import AdminApi from "@/api/admin.api";

const errorHandler = error => {
    Vue.prototype.$eventHub.$emit("profile.error", error);
};

const actions = {
    operatorFetchProfile({ commit }, id) {
        commit("setLoading");
        return AdminApi.Users.get(id)
            .then(res => {
                commit("setError", null);
                commit("setData", res.data.data);
            })
            .catch(err => {
                commit("setError", err.response.data.message);
            })
            .finally(res => {
                commit("setLoading", false);
            });
    },
    operatorFetchAccounts({ commit }, id) {
        commit("setAccountsLoading");
        return AdminApi.Users.getAccounts(id)
            .then(res => {
                commit("setError", null);
                commit("setAccounts", res.data);
            })
            .catch(err => {
                commit("setError", err.response.data.message);
            })
            .finally(res => {
                commit("setAccountsLoading", false);
            });
    },
    operatorUpdateProfile({ commit }, { id, data }) {
        return AdminApi.Users.update(id, data)
            .then(res => {
                commit("setData", res.data);
            })
    },
    async operatorFetchDocuments({ commit }, id) {
        const { data } = await AdminApi.Users.getDocuments(id).catch(errorHandler);
        commit("setDocuments", data);
    },
    async operatorFetchCertificate({ commit }, id) {
        const { data } = await AdminApi.Users.getCertificate(id).catch(errorHandler);
        commit("setCertificate", data);
    },
    async operatorAcceptProfile({ commit }, id) {
        const { data } = await AdminApi.Users.acceptProfile(id).catch(errorHandler);
        commit("setData", data);
    },
    async operatorDeclineProfile({ commit }, { id, message }) {
        const { data } = await AdminApi.Users.declineProfile(id, message).catch(errorHandler);
        commit("setData", data);
    },
    operatorDeleteProfile({ commit }, id) {
        return AdminApi.Users.deleteProfile(id);
    },
    operatorRefillAccount({ commit }, { id, summ }) {
        commit("setAccountsLoading");
        return AdminApi.Users.refillAccount(id, summ)
            .then(res => {
                commit("setAccounts", res.data);
            })
            .finally(res => {
                commit("setAccountsLoading", false);
            });
    },
    operatorWithdrawAccount({ commit }, { id, summ }) {
        commit("setAccountsLoading");
        return AdminApi.Users.withdrawAccount(id, summ)
            .then(res => {
                commit("setAccounts", res.data);
            })
            .finally(res => {
                commit("setAccountsLoading", false);
            });
    },
};

export default actions;
